<!--
 * @Author: yangxiaofeng
 * @Date: 2024-07-04 21:22:16
 * @LastEditors: yangxiaofeng
 * @LastEditTime: 2024-07-04 21:37:24
 * @FilePath: /ystOpenPlatform/src/components/public/ComFooter.vue
 * @Description: 
-->
<template>
	<!--公共尾部-->
       <div class="footer_wrap">
			<div class="footerIn">
				<div class="fllter_l ft14">
					<p class="footer_link"><a href="javascript:;">服务协议</a> | <a href="javascript:;">常见问题</a> | <a href="javascript:;">关于我们</a></p>
					<!-- <p class="compansyNews">版权所有 © 银税通 All rights reserved  |  京ICP备15045264号-3</p> -->
				</div>
				<div class="fllter_r fr">
					<span class="footer_phone third_font">010-8478 2635</span>
					<span class="footer_eamil third_font">market@yinshuitong.com</span>
				</div>
			</div>
			<p class="compansyNews">
				版权所有 © 百望股份有限公司 All rights reserved
            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802032293">   <span><img src='../../assets/images/policeLogo.png'></img> 京公网安备 11010802032293号   </span></a><a href="https://beian.miit.gov.cn" target="_blank">京ICP备15045264号-3</a>
			</p>
		</div>
</template>

<script>
	export default {
	  name: 'comFooter'
	}
</script>

<style lang="scss">
	/****/
.footer_wrap{width: 100%;float: left; background:$white; padding: 30px 0; border-top: 1px solid $border; color: $title;}
.footerIn{width: 1000px;height: 100%;margin: 0 auto;}
.fllter_l{ float: left;width: 500px;height:46px;line-height:46px}
.footer_link{ color:$gredF;}
.footer_link a{ color:$link;}
.fllter_r{ float: left;font-size: 20px;}
.fllter_r span{ padding-left:43px;display: inline-block; height:46px; line-height:40px;}
.footer_phone{ background: url(../../assets/images/phone.png) no-repeat left top; margin-right: 30px;background-size: 35px 46px;}
.footer_eamil{ background: url(../../assets/images/email.png) no-repeat left top;background-size: 35px 46px;}
.compansyNews{width:100%;margin-top:63px;text-align:center}
.compansyNews a{
	margin-left: 20px;
 color:#485166 !important;
 font-size:14px;
}
.compansyNews img{
	position:relative;
	top:5px;
}
</style>


// WEBPACK FOOTER //
// src/components/public/ComFooter.vue